import PieMenu from 'react-pie-menu';
import styled from 'styled-components';

const generateExplorerAnimation = (explorers) => {
  const animationCss = explorers.map((explorer) => {
    const element = document.querySelector(`div#${explorer.id}`);
    if (!element) return '';

    const expolorerBoundingRect = element.getBoundingClientRect();
    const navigationButtonBoundingRect = document.querySelector(`button#${explorer.id}`).getBoundingClientRect();
    const elementXtransition = navigationButtonBoundingRect.x - expolorerBoundingRect.x;
    const elementYTransition = window.innerHeight / 2 - (expolorerBoundingRect.y + expolorerBoundingRect.height);

    return `
          & ul > li .${explorer.id}Animation {
            animation-name: ${explorer.id}Animation !important;
            animation-duration: 0.8s;
            animation-iteration-count: 1;
            transform: translate( ${elementXtransition}px, ${elementYTransition}px);
          }

          @keyframes ${explorer.id}Animation {
            from {
              transform: translate(0px, 0px);
            }
            to {
              transform: translate( ${elementXtransition}px, ${elementYTransition}px);
            }
          }

          `;
  });
  return animationCss.join(' ');
};

export const StyledPieMenu = styled(PieMenu)`
  & ul > li {
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 115px;
      width: 320px;
      height: 0;
      border-color: #e0edf4;
      border-width: 0px 0px 4px 4px;
      border-left: 180px solid transparent;
      border-style: solid;
      border-image: linear-gradient(to left, #e0edf4, #e0edf4, #e0edf4, #d8f1ff6b) 1;
    }
  }
  & ul > li > div > div {
    transform: rotate(325deg);
    margin-top: -5px;
  }

  ${(props) => generateExplorerAnimation(props.explorers)}

  & ul > li.fadeOutAnimation {
    &:after {
      content: none;
      border: none;
    }
  }

  & ul > li.fadeOutAnimation > div {
    position: relative;
    background-color: transparent;
    box-shadow: none;
    animation-name: explorerClickedAnimationFadeOut !important;
    animation-duration: 0.1s !important;
    animation-iteration-count: 1;
  }

  // 360 wheel fade out animation
  & ul > li.fadeOutAnimation > div[_highlight][enabled='true'] {
    color: rgba(0, 103, 172, 0.8);
    cursor: pointer;
    background: transparent;
  }
`;
